import { FC, useEffect, useState } from 'react';
import Page from 'src/components/Page';
import { Box } from '@mui/system';
import { QuestionnarieModal } from 'src/components/QuestionnarieModal';
import { getFeedbackQuestionnaire } from 'src/constants/surveyJson/feedbackQuestionnaire';
import { QuestionnaireStatus, QuestionnaireTypeEnum } from 'src/types';
import { useQuestionnaire } from 'src/components/cards/useQuestionnaire';
import { useParams } from 'react-router';
import { dispatch } from 'src/redux/store';
import { openModal } from 'src/redux/slices/modal';
import { getTransactionQuestionnaire, selectTransactionQuestionnaire } from 'src/redux/slices/transactionQuestionnaire';
import { fillQuestionnaireJsonWithCompletedData } from 'src/utils/questionnaire';
import { useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { AuthPage } from '../auth/styles';
import { ProvideTransactionFeedbackProps } from './types';

const ProvideTransactionFeedback: FC<ProvideTransactionFeedbackProps> = ({ side }) => {
	const { id } = useParams();
	const key = `${side}_feedback` as const;
	const [isOpen, setIsOpen] = useState(true);
	const transactionQuestionnaire = useSelector(selectTransactionQuestionnaire);
	const { onSubmit, onPageChanged, onComplete } = useQuestionnaire({
		type: key,
		questionnaireType: QuestionnaireTypeEnum.TRANSACTION,
		transactionId: id,
	});

	console.log('transactionQuestionnaire', transactionQuestionnaire);

	useEffect(() => {
		dispatch(getTransactionQuestionnaire({ id: id as string }));
		dispatch(openModal({ name: key }));
	}, [key, id]);

	const handleComplete = async () => {
		await onComplete();
		setIsOpen(false);
	};

	const completedFeedbackQuestionnaire = fillQuestionnaireJsonWithCompletedData(
		getFeedbackQuestionnaire(),
		transactionQuestionnaire?.[key],
	);

	return (
		<Page title='Quote'>
			<AuthPage>
				<Box display='flex' alignItems='center' flexDirection='column'>
					<QuestionnarieModal
						questionnaireType={QuestionnaireTypeEnum.TRANSACTION}
						questionnaireKey={key}
						surveyJson={completedFeedbackQuestionnaire}
						status={QuestionnaireStatus.NOT_STARTED}
						onSubmit={onSubmit}
						onComplete={handleComplete}
						onPageChanged={onPageChanged}
						title='FEEDBACK'
						withFinishLater={false}
						withPreSubmit={false}
						open={isOpen}
					/>
					{!isOpen && <Typography variant='h1'>Thank you for your feedback!</Typography>}
				</Box>
			</AuthPage>
		</Page>
	);
};

export default ProvideTransactionFeedback;
